var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { fetchQuotaUsages } from "@/api/users";
import { QuotaUsage } from "./model/index";
export function fetch() {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield fetchQuotaUsages({ user_id: "current" });
        return data.map((u) => new QuotaUsage(u));
    });
}
